"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function SessionCta() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="reikisessioncta" data-nav="light" className="bg-background py-20 md:py-28 text-foreground">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.6,
        ease: "easeOut"
      }} className="max-w-3xl mx-auto rounded-2xl bg-secondary/40 border border-border p-8 md:p-12 text-center shadow-xs">
          <h3 className="font-serif text-2xl md:text-3xl lg:text-4xl text-primary font-normal leading-tight">
            Bereit für Deine persönliche Auszeit?
          </h3>
          <p className="font-sans text-sm md:text-base text-muted-foreground mt-4 md:mt-6 max-w-xl mx-auto leading-relaxed">
            Buche Deine individuelle Reiki-Sitzung oder lasse Dich in einem unverbindlichen Vorabgespräch beraten.
          </p>

          <div className="mt-8 md:mt-10 flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button asChild size="lg" className="w-full sm:w-auto rounded-full px-7 shadow-xs">
              <Link to="/ContactPage">
                Termin vereinbaren
                <ArrowRight className="size-4.5" />
              </Link>
            </Button>

            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto rounded-full px-7">
              <Link to="/AngebotePage">
                Alle Angebote ansehen
              </Link>
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}